import { AvailableMembershipPlan } from '@/models/api/paid-member-price/member-plan/available-membership-plan'
import { lastDayOfMonth } from 'date-fns'

/**
 * あるプランをある日付で解約した時、そのプランがいつまで有効であるかを取得する.
 */
export interface LastActiveDateSpecification {
  whenUnsubscribedAt(plan: AvailableMembershipPlan, unsubscribeAt: Date): Promise<Date>
}

/**
 * 解約後は「解約した当月中まで有効」で一定であると前提した暫定実装.
 *
 * # 将来的に、Engineのルール定義と連動した実装に入れ替える必要あり
 * この実装を残しておくと、裏側でEngineの設定が変更された時、Frontの表示と整合しなくなる恐れがある.
 *
 * # 経緯
 * Engine側に「このプランなら、解約後は〜まで」といった定義はされており、Frontでの算出は可能と思われるが、
 * 以下の理由から、 https://github.com/my-color/front/issues/6152 では「指定した当月中」でハードコード対応とした.
 *
 * - ledian v1 では「指定した当月中」で確定している
 * - Engine側が各ルールごとにどのように算出しているのかを把握する必要がある
 *   - 理想は、Engineに問い合わせの口が用意されることだが、望み薄
 * - ledian v1 のリリースが 2022/03 末頃と見られている + バグ対応も残っており、時間的余裕が少ない
 *
 * 将来的にEngine設定値ないしEngine APIを参照する必要があることから、
 * この実装は特に非同期処理を伴わないものの、変更時にI/Fが壊れないよう初めから非同期定義にしている.
 *
 * @see https://github.com/my-color/front/issues/6152
 * @see https://github.com/my-color/front/issues/6152#issuecomment-1055124172
 */
export const onlyWithinTheUnsubscribedMonth: LastActiveDateSpecification = {
  async whenUnsubscribedAt(_: AvailableMembershipPlan, unsubscribedAt: Date): Promise<Date> {
    return lastDayOfMonth(unsubscribedAt)
  },
}
